// data/index.ts - Updated room descriptions
import {
  FaWifi,
  FaCoffee,
  FaBath,
  FaParking,
  FaSwimmingPool,
  FaHotdog,
  FaStopwatch,
  FaCocktail,
} from 'react-icons/fa';
import type { Room } from '../types';
import images from '../assets';

const facilities = {
  wifi: { name: 'Wifi', icon: FaWifi },
  coffee: { name: 'Coffee', icon: FaCoffee },
  bath: { name: 'Bath', icon: FaBath },
  parking: { name: 'Parking Space', icon: FaParking },
  pool: { name: 'Swimming Pool', icon: FaSwimmingPool },
  breakfast: { name: 'Breakfast', icon: FaHotdog },
  gym: { name: 'GYM', icon: FaStopwatch },
  drinks: { name: 'Drinks', icon: FaCocktail },
};

const allFacilities = Object.values(facilities);

// Unique descriptions for each room
const descriptions = {
  superior: "Experience comfort and elegance in our Superior Room. Featuring modern amenities, plush bedding, and a serene atmosphere, this room is perfect for the discerning traveler seeking a restful stay.",
  
  signature: "Our Signature Room offers an elevated experience with spacious interiors, premium furnishings, and breathtaking views. Enjoy the perfect blend of luxury and comfort in this meticulously designed space.",
  
  deluxe: "Step into luxury with our Deluxe Room, featuring contemporary design, high-end amenities, and ample space for relaxation. Perfect for those who appreciate the finer things in life.",
  
  luxury: "Indulge in the ultimate luxury experience with our premium room. Featuring exquisite decor, state-of-the-art amenities, and personalized service, this room redefines hospitality.",
  
  suite: "Our Luxury Suite Room offers unparalleled elegance with separate living and sleeping areas, premium amenities, and stunning views. Experience the pinnacle of luxury living.",
  
  deluxe2: "Experience modern comfort in our Deluxe Room, featuring sophisticated design, premium amenities, and a relaxing ambiance. Perfect for business and leisure travelers alike.",
  
  luxury2: "Our Luxury Room combines contemporary style with ultimate comfort. Featuring high-end amenities, plush furnishings, and exceptional service for an unforgettable stay.",
  
  deluxe3: "Indulge in our Deluxe Room's modern elegance, featuring premium amenities, comfortable bedding, and a tranquil atmosphere. Perfect for a memorable stay."
};

// Static room list
export const roomData: Room[] = [
  {
    id: 1,
    name: 'Superior Room',
    shortDescription: "Experience luxury and comfort in our superior room",
    description: descriptions.superior,
    facilities: [facilities.wifi, facilities.breakfast],
    size: 30,
    maxPerson: 1,
    price: 115,
    image: images.Room1Img,
    imageLg: images.Room1ImgLg,
  },
  {
    id: 2,
    name: 'Signature Room',
    shortDescription: "Experience elegance in our signature room",
    description: descriptions.signature,
    facilities: allFacilities,
    size: 70,
    maxPerson: 2,
    price: 220,
    image: images.Room2Img,
    imageLg: images.Room2ImgLg,
  },
  {
    id: 3,
    name: 'Deluxe Room',
    shortDescription: "Modern comfort meets luxury",
    description: descriptions.deluxe,
    facilities: allFacilities,
    size: 50,
    maxPerson: 3,
    price: 265,
    image: images.Room3Img,
    imageLg: images.Room3ImgLg,
  },
  {
    id: 4,
    name: 'Luxury Room',
    shortDescription: "Experience premium luxury and comfort",
    description: descriptions.luxury,
    facilities: allFacilities,
    size: 50,
    maxPerson: 4,
    price: 289,
    image: images.Room4Img,
    imageLg: images.Room4ImgLg,
  },
  {
    id: 5,
    name: 'Luxury Suite Room',
    shortDescription: "The ultimate suite experience",
    description: descriptions.suite,
    facilities: allFacilities,
    size: 90,
    maxPerson: 5,
    price: 320,
    image: images.Room5Img,
    imageLg: images.Room5ImgLg,
  },
  {
    id: 6,
    name: 'Deluxe Room',
    shortDescription: "Contemporary comfort and style",
    description: descriptions.deluxe2,
    facilities: allFacilities,
    size: 45,
    maxPerson: 6,
    price: 344,
    image: images.Room6Img,
    imageLg: images.Room6ImgLg,
  },
  {
    id: 7,
    name: 'Luxury Room',
    shortDescription: "Where luxury meets comfort",
    description: descriptions.luxury2,
    facilities: allFacilities,
    size: 84,
    maxPerson: 7,
    price: 389,
    image: images.Room7Img,
    imageLg: images.Room7ImgLg,
  },
  {
    id: 8,
    name: 'Deluxe Room',
    shortDescription: "Premium comfort in a modern setting",
    description: descriptions.deluxe3,
    facilities: allFacilities,
    size: 48,
    maxPerson: 8,
    price: 499,
    image: images.Room8Img,
    imageLg: images.Room8ImgLg,
  },
];

// Export facilities for use in other components
export { facilities, allFacilities };